<template>
  <div class="summary-accordion-container">
    <ul
      id="recent-addendum-summary-accordion"
      class="accordion summary-accordion accordion-customize"
      data-accordion
      data-deep-link="true"
      data-allow-all-closed="true"
      data-multi-expand="true"
      data-update-history="true"
      data-deep-link-smudge="500"
    >
      <li
        class="accordion-item"
        data-accordion-item
      >
        <a
          :href="'#addendum-summary-accordion-0'"
          class="accordion-title"
        >
          {{ $t('summary.name') }}
        </a>
        <div
          id="addendum-summary-accordion-0"
          class="accordion-content"
          data-tab-content
        >
          <ul
            id="recent-addendum-accordion"
            class="accordion"
            data-accordion
            data-deep-link="true"
            data-allow-all-closed="true"
            data-multi-expand="true"
            data-update-history="true"
            data-deep-link-smudge="500"
          >
            <li
              v-for="(revision, index) in filteredAddendums"
              :key="index"
              class="accordion-item"
              :class="{'is-active': index === 0}"
              data-accordion-item
            >
              <a
                :href="'#addendum-accordion-' + index"
                class="accordion-title"
              >
                {{ $t('summary.location.addendum') }} {{ revision.version }}
                <i
                  v-if="isPicView"
                  class="fa fa-pencil fa-lg icon accordion-title-edit-icon"
                  @click.stop.prevent="editComment(index)"
                />
                <span
                  v-if="revision.commentUpdatedBy && revision.commentUpdatedAt"
                  class="edit-history"
                >
                  {{ $t('lastUpdatedBy', [revision.commentUpdatedBy, dateUtil.format(revision.commentUpdatedAt, dateUtil.DD_MMM_YY_HH_MM)]) }}
                </span>
                <p
                  v-if="!showEditArea(index)"
                  class="accordion-comment"
                >
                  {{ revision.comment }}
                </p>
                <div
                  @click.stop.prevent=""
                  @keydown.stop=""
                >
                  <textarea
                    v-if="showEditArea(index)"
                    :ref="'edit-comment-area-' + index"
                    v-model="revision.comment"
                    rows="3"
                    :placeholder="$t('summary.addendumComment')"
                    @blur="saveComment(revision)"
                  />
                </div>
              </a>
              <div
                :id="'addendum-accordion-' + index"
                class="accordion-content"
                data-tab-content
              >
                <addendum-item :addendums="revision.addendum" />
              </div>
            </li>
          </ul>
          <slot name="vendor-bid-status" />
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import { diffAllVersions } from '@/api/tender-addendums/request'
import AddendumItem from '@/modules/tenders/review/AddendumItem'
import dateUtil from '@/utils/dateUtil'
import termsOfConditionsMixin from '@/modules/tenders/termsOfConditionsMixin'

export default {
  components: {
    AddendumItem,
  },
  mixins: [termsOfConditionsMixin],
  props: {
    tenderId: {
      type: String,
      default: '',
    },
    includePendingChange: {
      type: Boolean,
      default: true,
    },
    addendumVersion: {
      type: Number,
      default: 0,
    },
    isBid: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      addendums: [],
      dateUtil,
      currentCommentIndex: -1,
    }
  },
  methods: {
    ...mapActions('tenders', [
      'updateAddendumComment',
    ]),
    timeout (ms) {
      return new Promise(resolve => setTimeout(resolve, ms))
    },
    initAccordion () {
      if (this.summaryAccordion) {
        this.summaryAccordion.destroy()
      }
      if (!this.summaryAccordion) {
        this.summaryAccordion = new Foundation.Accordion($('#recent-addendum-summary-accordion'))
      }
      if (this.accordion) {
        this.accordion.destroy()
      }
      if (!this.accordion) {
        this.accordion = new Foundation.Accordion($('#recent-addendum-accordion'))
      }
    },
    async refreshPage () {
      this.addendums = await diffAllVersions(this.tenderId || this.$router.currentRoute.params.id)
      setTimeout(this.initAccordion, 0)
    },
    async editComment (index) {
      this.currentCommentIndex = index
      await this.$nextTick()
      this.$refs[`edit-comment-area-${index}`][0].focus()
    },
    showEditArea (index) {
      return this.currentCommentIndex === index
    },
    async saveComment (revision) {
      await this.updateAddendumComment({
        tenderId: this.$router.currentRoute.params.id,
        commentIndex: revision.oldVersion,
        content: revision.comment,
      })
      this.currentCommentIndex = -1
      this.addendums = await diffAllVersions(this.tenderId || this.$router.currentRoute.params.id)
    },
  },
  watch: {
    async tenderId (val) {
      if (val) {
        await this.refreshPage()
      }
    },
  },
  destroyed () {
    if (this.accordion) {
      this.accordion.destroy()
    }
  },
  async mounted () {
    await this.loadTenderDepartment(this.$router.currentRoute.params.id, this.isBid)
    await this.refreshPage()
  },
  computed: {
    ...mapGetters('tenders', ['currentBid', 'isPicView']),
    filteredAddendums () {
      if (this.addendumVersion > 0) {
        return this.addendums.filter(addendum => addendum.version <= this.addendumVersion)
      }
      if (this.includePendingChange && this.addendums[0]) {
        return this.addendums
      } else if (!this.includePendingChange && this.addendums[1]) {
        this.addendums.shift()
        return this.addendums
      }
      return []
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~styles/accordion';

#addendum-summary-accordion-0 {
  background: white;
}
.accordion-title {
  .edit-history {
    font-style: italic;
    margin: 0;
    margin-top: 10px;
    color: #a3a3a3;
    font-size: 12px;
    margin-left: 20px;
  }
  .accordion-title-edit-icon{
    font-size:1em;
  }
}

</style>
